export default "__VITE_ASSET__WMV8myGl__"